export default class OptionModel {
  constructor(option) {
    this.option = option;
  }

  get id() {
    return this.option.id;
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/fluxogram/models/option.js
 **/